var cibGg = ["32 32", "<path d='M11.2 14.4l6.4 6.4-6.4 6.4-11.2-11.2 11.2-11.2 2.8 2.8-1.6 1.6-1.2-1.2-8 8 8 8 3.219-3.219-4.819-4.781zM20.8 4.8l-6.4 6.4 6.4 6.4 1.6-1.6-4.819-4.781 3.219-3.219 8 8-8 8-1.2-1.2-1.6 1.6 2.8 2.8 11.2-11.2z'/>"];

export { cibGg };
//# sourceMappingURL=cib-gg.js.map
